import { ComponentModalConfig, ModalSize } from 'ngx-fomantic-ui';
import {
  ConfirmModalComponent,
  IConfirmModalContext,
} from '../confirm-modal/confirm-modal.component';

export class ConfirmModal extends ComponentModalConfig<
  IConfirmModalContext,
  void,
  void
> {
  constructor(title?: string, message?: string, size?: any) {
    super(ConfirmModalComponent, { title, message });
    this.isClosable = false;
    this.transitionDuration = 500;
    this.size = ModalSize[size] || ModalSize.Mini;
  }
}
